import styles from './DripDelayNode.module.scss'

function DripDelayNode({ value, unit, onClick, isDisabledByPrevious = false }) {
  const displayText = `${value} ${unit}`
  const wrapperClassName = isDisabledByPrevious
    ? `${styles.wrapper} ${styles.disabledByPrevious}`
    : styles.wrapper

  return (
    <div className={wrapperClassName}>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.icon}>⏱</div>
          <span className={styles.label}>Wait before sending the next message</span>
          <button
            className={styles.timeButton}
            onClick={isDisabledByPrevious ? undefined : onClick}
            type="button"
          >
            {displayText}
          </button>
        </div>
      </div>
    </div>
  )
}

export default DripDelayNode
